module.exports = __webpack_public_path__ + "media/images/athletes/1168-e618fc1a59df6c009ede61410a6ce583.png";